import { Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { CuestionariosService } from '../services/cuestionarios.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-opciones-dialog',
  templateUrl: './opciones-dialog.component.html',
  providers: [MessageService]
})
export class OpcionesDialogComponent implements OnInit, OnChanges {
  @Input() displayDialog: boolean = false;
  @Input() preguntaSeleccionada: any = null;
  @Input() cuestionario: any = null;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() onHide = new EventEmitter<{refresh: boolean}>();
  @ViewChild('dt') table!: Table;

  loading: boolean = false;
  opciones: any[] = [];
  displayedColumns = [
    { field: 'iNumOpcion', header: 'N° Opción' },
    { field: 'sValorStr', header: 'Valor' },
    { field: 'dRango1', header: 'Rango 1' },
    { field: 'dRango2', header: 'Rango 2' },
    { field: 'iScore', header: 'Score' },
    { field: 'iSigPreg', header: 'Sig. Pregunta' },
    { field: 'actions', header: 'Acciones' }
  ];

  displayNuevaOpcionDialog: boolean = false;
  opcionSeleccionada: any = null;

  constructor(
    private messageService: MessageService,
    private cuestionariosService: CuestionariosService
  ) {}

  ngOnInit(): void {
    this.cargarOpciones();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['displayDialog'] && this.displayDialog) {
      this.cargarOpciones();
    }
  }

  cargarOpciones(): void {
    if (!this.cuestionario || !this.preguntaSeleccionada) return;

    this.loading = true;
    const request = {
      que: 4,
      tope: "999",
      sClaveCues: this.cuestionario.sClaveCues,
      iNumPreg: this.preguntaSeleccionada.iNumPreg,
      iNumOpcion: 0,
      sValorStr: "",
      dRango1: 0,
      dRango2: 0,
      iScore: 0,
      iSigPreg: 0
    };

    this.cuestionariosService.getOpciones(request).subscribe({
      next: (response) => {
        if (response.success) {
          this.opciones = response.data;
        }
      },
      error: (error) => {
        console.error('Error al cargar opciones:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudieron cargar las opciones'
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openNew(): void {
    this.opcionSeleccionada = null;
    this.displayNuevaOpcionDialog = true;
  }

  editOpcion(opcion: any): void {
    console.log('Editando opción:', opcion);
    this.opcionSeleccionada = { ...opcion };
    this.displayNuevaOpcionDialog = true;
  }

  deleteOpcion(opcion: any): void {
    Swal.fire({
      title: '¿Estás seguro?',
      text: `¿Deseas eliminar la opción ${opcion.iNumOpcion}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        const request = {
          que: 3,
          tope: "",
          sClaveCues: this.cuestionario.sClaveCues,
          iNumPreg: this.preguntaSeleccionada.iNumPreg,
          iNumOpcion: opcion.iNumOpcion,
          sValorStr: opcion.sValorStr,
          dRango1: opcion.dRango1,
          dRango2: opcion.dRango2,
          iScore: opcion.iScore,
          iSigPreg: opcion.iSigPreg
        };

        this.cuestionariosService.eliminarOpcion(request).subscribe({
          next: (response) => {
            if (response.success && response.data.error === "0") {
              Swal.fire({
                title: '¡Eliminado!',
                text: 'La opción ha sido eliminada correctamente.',
                icon: 'success'
              });
              this.cargarOpciones();
            } else {
              Swal.fire({
                title: 'Error',
                text: 'No se pudo eliminar la opción.',
                icon: 'error'
              });
            }
          },
          error: (error) => {
            console.error('Error al eliminar opción:', error);
            Swal.fire({
              title: 'Error',
              text: 'Ocurrió un error al eliminar la opción.',
              icon: 'error'
            });
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
    this.onHide.emit({ refresh: false });
  }

  onNuevaOpcionDialogClosed(event: {refresh: boolean}): void {
    this.displayNuevaOpcionDialog = false;
    this.opcionSeleccionada = null;
    if (event.refresh) {
      this.cargarOpciones();
    }
  }
} 